import { Component, input, OnInit, output } from '@angular/core';
import { Asset } from 'app/classes/asset';
import { APIService } from 'app/shared/api.service';


@Component({
  selector: 'app-dialog-asset-edit',
  templateUrl: './dialog-asset-edit.component.html',
  styleUrls: ['./dialog-asset-edit.component.css'],
  providers: [],
  standalone: false
})
export class DialogAssetEditComponent implements OnInit {

  asset = input.required<Asset>(); Asset;
  isWorking: boolean;
  title: string;
  location: string;
  onClose = output<boolean>();

  constructor(private apiService: APIService) {

  }

  ngOnInit(): void {
    this.title = this.asset().title;
    this.location = this.asset().location;
  }

  cancel() {

  }

  async update() {
    if (this.isWorking) {
      return;
    }
    this.isWorking = true;
    let hasChanged = false;


    if (this.location !== this.asset().location) {
      await this.apiService.save(this.asset().id, 'assets.location', this.asset().location);
      hasChanged = true;
    }
    if (this.title !== this.asset().title) {
      await this.apiService.save(this.asset().id, 'assets.display', this.asset().title);
      hasChanged = true;
    }

    if (hasChanged) {
      this.apiService.toastSuccess('Asset updated.');
      this.onClose.emit(true);
    } else {
      this.apiService.toastWarn('Nothing to update.', 'No changes detected.');
    }
    this.isWorking = false;
  }
}

